import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const DEFAULT_TITLE = 'Mohamed Amine Nasfi - Full-Stack Developer';

export const useDocumentMeta = (pageTitle) => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const baseTitle = t('meta.title', { defaultValue: DEFAULT_TITLE });
    document.title = pageTitle ? `${pageTitle} | ${baseTitle.split(' - ')[0]}` : baseTitle;

    const description = t('meta.description');
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', description);

    document.documentElement.lang = i18n.language;
  }, [t, i18n.language, pageTitle]);
};

export default useDocumentMeta;
